export default __webpack_public_path__ + "static/media/korl.10720c3b.gif";